import axios from "axios";
import { BASE_URL } from "../Utils/base_url";

const ContactRequest = async (data) => {
    return await axios.post(`${BASE_URL}/ajouteContact`, data);
}

const AbonnemetRequest = async (data) => {
    return await axios.post(`${BASE_URL}/abonnement`, data);
}

export { ContactRequest, AbonnemetRequest };